function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 9C20.6642 9 21 9.33579 21 9.75V17.25C21 17.6642 20.6642 18 20.25 18C19.8358 18 19.5 17.6642 19.5 17.25V9.75C19.5 9.33579 19.8358 9 20.25 9Z",
  fill: "#F5841F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.25 9C24.6642 9 25 9.33579 25 9.75V17.25C25 17.6642 24.6642 18 24.25 18C23.8358 18 23.5 17.6642 23.5 17.25V9.75C23.5 9.33579 23.8358 9 24.25 9Z",
  fill: "#F5841F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.23 22.6289C21.2733 22.6289 20.3478 22.4733 19.4844 22.1933C19.2122 22.1 18.9089 22.17 18.6989 22.38L17.4778 23.9122C15.2767 22.8622 13.2156 20.8789 12.1189 18.6L13.6356 17.3089C13.8456 17.0911 13.9078 16.7878 13.8222 16.5156C13.5344 15.6522 13.3867 14.7267 13.3867 13.77C13.3867 13.35 13.0367 13 12.6167 13H9.92556C9.50556 13 9 13.1867 9 13.77C9 20.9956 15.0122 27 22.23 27C22.7822 27 23 26.51 23 26.0822V23.3989C23 22.9789 22.65 22.6289 22.23 22.6289Z",
  fill: "#F5841F"
});

function SvgOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.1d174caa.svg";
export { ForwardRef as ReactComponent };